import ProgramEvents from "./ProgramEvents";
import { Program, ProgramDetail, BackendList } from "./model/Program";

//受講中プログラム取得
export const GetLearningProgram = (id: string) =>
    ({
        type: ProgramEvents.GetLearningProgramStarted,
        userId: id,
    } as const);

export const GetLearningProgramComplete = (programList: Program[]) =>
    ({
        type: ProgramEvents.GetLearningProgramComplete,
        programList,
    } as const);

// プログラムにエピソード・関連Videoを追加
export const AddVideoToProgram = (
    userId: string,
    programId: string,
    videoId: string,
    videoType: number
) =>
    ({
        type: ProgramEvents.AddVideoToProgram,
        userId,
        programId,
        videoId,
        videoType,
    } as const);
export const AddVideoToProgramComplete = (program: ProgramDetail) =>
    ({
        type: ProgramEvents.AddVideoToProgramComplete,
        program,
    } as const);

//プログラム一覧取得
export const GetAllProgram = (id: string) =>
    ({
        type: ProgramEvents.GetAllProgramStarted,
        userId: id,
    } as const);

export const GetAllProgramComplete = (allProgramList: ProgramDetail[]) =>
    ({
        type: ProgramEvents.GetAllProgramComplete,
        allProgramList,
    } as const);

// プログラム更新（プログラム管理用）
export const UpdateProgram = (
    userId: string,
    updateListItems: BackendList[],
    deleteListIdItems: number[]
) =>
    ({
        type: ProgramEvents.UpdateProgramStarted,
        userId,
        updateListItems,
        deleteListIdItems,
    } as const);

export const UpdateProgramComplete = (allProgramList: ProgramDetail[]) =>
    ({
        type: ProgramEvents.UpdateProgramComplete,
        allProgramList,
    } as const);

export const UpdateProgramFailed = (error: string) =>
    ({
        type: ProgramEvents.UpdateProgramFailed,
        error,
    } as const);
